import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
// @ts-ignore Temporarily do not proceed  the action package ts
import { Transition } from '@douyinfe/semi-animation-react';
import React from 'react';
export default function ContentTransition() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    motion: motionFromProps,
    children,
    controlled,
    visible
  } = props;
  let motion = motionFromProps;
  let extra = {};

  if (typeof motion === 'function') {
    motion = motion(props);
  } else if (!motion || typeof motion !== 'object') {
    motion = {};
  }

  if (controlled) {
    extra = {
      // immediate: true,
      state: visible ? 'enter' : 'leave'
    };
  }

  return /*#__PURE__*/React.createElement(Transition, _Object$assign({
    config: {
      tension: 600,
      friction: 30
    },
    from: {
      scale: 0.7,
      opacity: {
        val: 0,
        duration: 180
      }
    },
    enter: {
      scale: {
        val: 1
      },
      opacity: {
        val: 1,
        duration: 90
      }
    },
    leave: {
      scale: {
        val: 0.7
      },
      opacity: {
        val: 0,
        duration: 75
      }
    }
  }, extra, motion), children);
}